import React, { useEffect, useState } from "react";
import config from '../../config';

const SubscriberList = () => {
    const [subscribers, setSubscribers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchSubscribers = async () => {
            try {
                const response = await fetch(`${config.backendUrl}/api/get_subscriptions`);
                if (!response.ok) {
                    throw new Error("Failed to fetch subscriptions");
                }
                const data = await response.json();
                setSubscribers(data);
            } catch (err) {
                setError("Failed to fetch subscriptions. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        fetchSubscribers();
    }, []);

    return (
        <div className="container mt-4">
            <h2 className="text-center">Subscribers List</h2>

            {loading ? (
                <div className="text-center mt-3">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : error ? (
                <div className="alert alert-danger text-center">{error}</div>
            ) : (
                <table className="table table-striped" style={{ marginLeft: "50px", marginTop: "40px" }}>
                    <thead style={{ backgroundColor: "blue", color: "white" }}>
                        <tr>
                            <th>ID</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th>Subscribed At</th>
                        </tr>
                    </thead>
                    <tbody>
                        {subscribers.length > 0 ? (
                            subscribers.map((subscriber) => (
                                <tr key={subscriber.id}>
                                    <td>{subscriber.id}</td>
                                    <td>{subscriber.email}</td>
                                    <td>{subscriber.role}</td>
                                    <td>{new Date(subscriber.subscribed_at).toLocaleString()}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" className="text-center">
                                    No subscribers found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default SubscriberList;
